import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { getIsCduUserInit } from '@gef-ui/cdu-user/selectors';

import { initializeApp } from 'app/configurator/actions/configurator';

import InitLoader from './InitLoader';

const Configurator = ({ children }) => {
	const dispatch = useDispatch();

	const isUserInit = useSelector(getIsCduUserInit);

	useEffect(() => {
		if (!isUserInit) {
			dispatch(initializeApp);
		}
	}, [dispatch, isUserInit]);

	return <InitLoader>{children}</InitLoader>;
};

Configurator.propTypes = {
	children: PropTypes.any,
};

export default Configurator;
